(function () {
  'use strict';

  function updateCartCount(count) {
    window.dispatchEvent(
      new CustomEvent('cartcount:update', { detail: { item_count: count } })
    );
  }

  function setBtn(btn, text, disabled) {
    btn.textContent = text;
    btn.disabled = disabled;
  }

  function handleSubmit(e) {
    if (!e.target || !e.target.classList.contains('atc-form')) return;
    e.preventDefault();

    var form = e.target;
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;

    var originalText = btn.textContent;
    setBtn(btn, 'Adding…', true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(form.querySelector('[name="id"]').value, 10),
        quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1
      })
    })
      .then(function (res) {
        if (!res.ok) return Promise.reject(res);
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        setBtn(btn, 'Added!', true);
        setTimeout(function () { setBtn(btn, originalText, false); }, 1400);
      })
      .catch(function () {
        setBtn(btn, 'Error — try again', false);
        setTimeout(function () { setBtn(btn, originalText, false); }, 2000);
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
